export default "__VITE_ASSET__BSoY9nXQ__"